import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Stepper from 'bs-stepper';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { AttributeModel, Lang, ReferenceParams } from 'src/app/models';
import { FileterConditions } from 'src/app/models/filter-conditions.model';
import { ApiOrganizationsService, ApiProductsService, NotificationService } from 'src/app/services';
import { ApiBasicService } from 'src/app/services/api-basic.service';
import { ApiUserOrgRolesService } from 'src/app/services/api-user-org-roles.service';
import { PermissionService } from 'src/app/services/permission.service';
import { runInThisContext } from 'vm';

@Component({
  selector: 'app-user-org-roles-controls',
  templateUrl: './user-org-roles-controls.component.html',
  styleUrls: ['./user-org-roles-controls.component.css'],
})
export class UserOrgRolesControlsComponent implements OnInit {
  progressRef: NgProgressRef;
  loading: boolean;

  subscriptions: Subscription = new Subscription();
  private stepper: Stepper;
  attributes: AttributeModel[] = [];
  filterConditionData: FileterConditions[] = [];
  userRoleId: string;
  roleName: Lang;
  currentOrg: any;
  checkValidation: boolean;
  ffInputLang: any = { name: '', valid: false };
  ffInputLangParams = {
    name: {
      clearField: true,
      required: true,
    },
  };

  selectedOperatorsForCondition: string = 'AND';
  condition = {
    [this.selectedOperatorsForCondition]: []
  };

  attributeForm: UntypedFormGroup = this.fb.group({
    attribute_id: [],
  });

  nameForm: UntypedFormGroup = this.fb.group({
    name: [null],
  });

  form: UntypedFormGroup = this.fb.group({
    id: [null],
    org_id: [null],
    urole_in_org_id: [null],
  });

  @Input() set data(value) {

    if (value) {

      this.userRoleId = value.u_role_id;
    }
  }

  constructor(
    public ngProgress: NgProgress,
    public activeModal: NgbActiveModal,
    public permissionAccess: PermissionService,
    private apiUserOrgService: ApiUserOrgRolesService,
    private apiOrganizations: ApiOrganizationsService,
    private notification: NotificationService,
    private apiProducts: ApiProductsService,
    private apiBasic: ApiBasicService,
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    this.progressRef = this.ngProgress.ref('progress-bar');
    this.currentOrg = this.apiOrganizations.currentOrganization;

    this.subscriptions.add(
      this.apiUserOrgService.listenerRoleId().subscribe((val) => {
        console.log(val);

        if (val) {

          this.userRoleId = val;

          // this.roleName = val.roleName;
          // val.action == 'create' ? this.onCreate() : this.onUpdate()
        }
      })
    );

    this.subscriptions.add(
      this.apiUserOrgService.listenerValidationData().subscribe((val) => {
        
        if (val) {

          val.module_id && val.module_id.length > 0 && val.permissions && val.permissions.length > 0 ? this.checkValidation = true : this.checkValidation = false;
          
        }
      })
    );

    if (this.userRoleId) {

      this.onEdit();
    }
    // this.initStepper()
    // this.getAttributes();
  }

  /**
   *
   */
  onEdit(): void {

    this.progressRef.start();
    this.loading = true;

    this.subscriptions.add(
      this.apiUserOrgService.edit(this.userRoleId).subscribe(

        (response) => {

          console.log('[RESPONSE] ORG_ROLE_EDIT: ', response);

          if (response != null) {

            if (response.result) {

              this.setDataInForm(response.result.name);
              this.apiUserOrgService.setRoleEdit(response.result);
              this.apiUserOrgService.setRoleId(response.result.id);
              this.apiUserOrgService.setFilterProductsData(response.result.filter_products);


            }
          }
          this.progressRef.complete();
          this.loading = false;
        },
        (error) => {
          this.progressRef.complete();
          this.loading = false;
        }
      )
    );
  }

  /**
   *
   */
  nextStep(): void {
    this.stepper.next();
  }

  /**
   *
   */
  prevStep(): void {
    this.stepper.previous();
  }

  // form: FormGroup = this.fb.group({
  //   filters: this.fb.array([])
  // });

  /**
   *
   * @param index
   */
  getAttributes(index: number = 0): void {
    
    let searchValue: string = '';

    let params: ReferenceParams = {
      ref_name: 'attributes',
      filter: {
        name: searchValue,
        type: ['INPUT', 'TEXTAREA'],
      },
    };

    this.subscriptions.add(this.apiBasic.getReferences(params, params.ref_name).subscribe((response: any) => {
    
      if (response != null) {
        this.attributes = response.result;
      }
    })
    );
  }


  /**
   * 
   * @param data 
   */
  productsData(productData) {

    let data = {
      role_id: this.userRoleId,
      org_id: this.currentOrg.id,
      condition: productData.operatorForContion,
      filter: productData.form.filters[0].attribute_id != null ? productData.form.filters : null
    }

    this.progressRef.start();
    this.loading = true;

    this.subscriptions.add(
      this.apiProducts.productFilterCreate(data).subscribe(
        (response) => {console.log('[RESPONSE] ORG_ROLE_PRODUCT_DATA: ', response);

          if (response != null) {


          }

          this.progressRef.complete();
          this.loading = false;
        },

        (error) => {
          this.progressRef.complete();
          this.loading = false;
        }
      )
    );
  }


  /**
   * permissonCheckbox
   * @param fieldName string
   * @param value Lang
   */
  eventFnFF(fieldName: string, value: any): void {
    
    this.ffInputLang = value;

    this.nameForm.controls[fieldName].setValue(value.name);
  }


  /**
   *
   */
  applyFilterData(data: any) {

    if (data) {

      this.productsData(data);
    }

    this.selectedOperatorsForCondition = data.operatorForContion;
    this.filterConditionData = data.form.filters;
  }


  /**
   *
   */
  resetFilter() {

    // Обнуляем значение фильтра
    this.filterConditionData = [];
    // Обнуляем условие оператор фильтрации
    this.condition[this.selectedOperatorsForCondition] = [];
  }


  /**
   *
   */
  setDataInForm(name: any): any {
    this.roleName = name;
  }


  /**
   *
   */
  onActionCreate(action: string) {

    let data = {
      id: this.userRoleId,
      action: action,
      roleName: this.nameForm.get('name').value,
    };

    if(action == 'create') {

      this.notification.show('success', 'Данные успешно сохранены!');
      this.activeModal.close(true);
    } else {

      this.notification.show('success', 'Данные успешно обновлены!');
      this.activeModal.close(true);
    }

    this.apiUserOrgService.setActinoData(data);
  }

  
  /**
   * 
   */
  close() {

    this.activeModal.close(false);
  }

}
